import styled from 'styled-components';
import { Button } from 'fpay-ui';

export default styled(Button)`
  width: 100px;
  ${({ theme }) => theme.breakpoint('md')} {
    text-align: center;
  }
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    width: inherit;
  }
`;
